const routes = {
  affidavitRegister: '/BeneficiariosFinales/es-register',
  foreignRegisterWizard: '/:language/registrarme',
  partnershipCertificate: '/socios-y-sociedades/certificado/:organizationCode/:purchaseMechanismId/:processType',
  partnershipCertificateSTU:
    '/socios-y-sociedades/certificado/:organizationCode/:purchaseMechanismId/:bidID/:processType',
  paymentFromRegister: '/pago/registro',
  registerWizard: '/registrarme',
  root: '/',
  taxesKeyAuth: '/registrarme/clave-tributaria',
  uniquePassAuth: '/auth/clave-unica',
  unsubscribe: '/desuscribirse',
  uniquePassAuthLogout: '/auth/clave-unica/logout'
}

export default routes
